import React from 'react';
/* eslint-disable */
export function FilterOutlined(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M0.572363 1.93273L0.57238 1.93274L0.574219 1.92883C0.698078 1.6661 0.959604 1.5 1.25008 1.5H14.7501C15.0406 1.5 15.3021 1.6661 15.4259 1.92883C15.5502 2.19251 15.5125 2.50201 15.3286 2.72733C15.3285 2.72738 15.3285 2.72743 15.3284 2.72748L9.61313 9.71147L9.50008 9.84962V10.0281V14C9.50008 14.19 9.39357 14.3622 9.22499 14.4457C9.05061 14.5321 8.85006 14.5129 8.70074 14.4005L8.70008 14.4L6.70008 12.9L6.70009 12.9L6.69769 12.8982C6.57433 12.8068 6.50008 12.6603 6.50008 12.5V10.0281V9.8496L6.38701 9.71145L0.668889 2.72472C0.668799 2.72461 0.66871 2.7245 0.66862 2.72439C0.486303 2.50046 0.4487 2.18928 0.572363 1.93273Z"
        stroke="url(#paint0_linear_1000_35469)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1000_35469"
          x1="0.000244141"
          y1="7.99979"
          x2="15.9984"
          y2="7.99979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD2476" />
          <stop offset="1" stopColor="#FF512F" />
        </linearGradient>
      </defs>
    </svg>
  );
}
